import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftCouponTheme, GiftCouponThemeList } from './giftCouponTheme.interface';

// 목록 조회 상태
export const giftCouponThemeListStatusAtom = atom<QueryStatus>({
  key: 'giftCouponThemeListStatusAtom',
  default: 'idle',
});

export const giftCouponThemeListDataAtom = atom<GiftCouponThemeList | null>({
  key: 'giftCouponThemeListDataAtom',
  default: null,
});

// 단건 조회 상태
export const giftCouponThemeStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponThemeStatusAtomFamily',
  default: 'idle',
});

export const giftCouponThemeDataAtomFamily = atomFamily<GiftCouponTheme | null, string>({
  key: 'giftCouponThemeDataAtomFamily',
  default: null,
});
